import InfoBar from "~/layouts/components/InfoBar/InfoBar";
import Banner from "../Banner/Banner";
import { FC } from "react";
import { BannerAction } from "~/entities/bannerEntities";

import styles from "./BannersAndInfoBar.module.css";

type BannersAndInfoBarProps = {
  onBannerAction: (action: BannerAction) => void;
};

const BannersAndInfoBar: FC<BannersAndInfoBarProps> = ({ onBannerAction }) => {
  return (
    <div className={styles.wrapper}>
      <Banner onBannerAction={onBannerAction} />
      <InfoBar />
    </div>
  );
};

export default BannersAndInfoBar;
